import React from "react";

interface DottedLineProps {
  startPercent: number; // 0-4 range
  endPercent: number; // 0-4 range
}

export const DottedLine: React.FC<DottedLineProps> = ({
  startPercent,
  endPercent,
}) => {
  // Konvertiere 0-4 Range zu Prozent (0-100)
  const startPercentConverted = (startPercent / 4) * 100;
  const endPercentConverted = (endPercent / 4) * 100;

  // Berechne die Positionen in der 600px ViewBox
  const totalWidth = 600;
  const startPosition = (startPercentConverted / 100) * totalWidth;
  const endPosition = (endPercentConverted / 100) * totalWidth;

  return (
    <svg
      className="dotted-line"
      preserveAspectRatio="none"
      viewBox="0 0 600 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1={startPosition}
        y1="1"
        x2={endPosition}
        y2="1"
        stroke="white"
        strokeDasharray="1 2"
      />
    </svg>
  );
};
